import Result from '../Result/Result';
import TestHome from '../../components/Home/TestHome';
const Switcher = ({
  showResult,
  results,
  weight,
  prefer,
  goBack,
  resetForm,
  btn,
  handleWeightChange,
  valuetext,
  handleWeightClick,
  preferChoose,
}) => {
  return (
    <>
      {showResult && results ? (
        <Result
          result={results}
          weight={weight}
          prefer={prefer}
          goBack={goBack}
          resetForm={resetForm}
        />
      ) : (
        <TestHome
          btn={btn}
          weight={weight}
          prefer={prefer}
          handleWeightChange={handleWeightChange}
          valuetext={valuetext}
          handleWeightClick={handleWeightClick}
          preferChoose={preferChoose}
        />
      )}
    </>
  );
};

export default Switcher;
